<div>
  <ng-content select="[dw-dropdown]"></ng-content>
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="hasBackdrop"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayOrigin]="dwOrigin"
  (backdropClick)="hide()"
  (detach)="hide()"
  [cdkConnectedOverlayMinWidth]="triggerWidth"
  (positionChange)="onPositionChange($event)"
  [cdkConnectedOverlayOpen]="dwVisible">
  <div
    class="{{'ant-dropdown ant-dropdown-placement-'+dwPlacement}}"
    [@dropDownAnimation]="dropDownPosition"
    (mouseenter)="onMouseEnterEvent()"
    (mouseleave)="onMouseLeaveEvent()"
    [style.minWidth.px]="triggerWidth">
    <div [class.ant-table-filter-dropdown]="hasFilterButton">
      <ng-content select="[dw-menu]"></ng-content>
      <ng-content select=".ant-table-filter-dropdown-btns"></ng-content>
    </div>
    <ng-content></ng-content>
  </div>
</ng-template>